(function () {
  'use strict';

  /* ─── Desktop Megamenu ─── */
  function initDesktopMegamenu() {
    var navItems = document.querySelectorAll('.pm-nav-item--has-dropdown');
    if (!navItems.length) return;

    var openItem = null;
    var closeTimer = null;

    function openPanel(item) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (openItem && openItem !== item) closePanelNow(openItem);
      if (openItem === item) return;

      var panelId = item.querySelector('.pm-nav-item__trigger').getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      if (!panel) return;

      item.classList.add('pm-nav-item--open');
      panel.removeAttribute('hidden');
      openItem = item;
    }

    function closePanelNow(item) {
      var trigger = item.querySelector('.pm-nav-item__trigger');
      if (!trigger) return;
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (panel) panel.setAttribute('hidden', '');
      item.classList.remove('pm-nav-item--open');
      if (openItem === item) openItem = null;
    }

    function scheduleClose(item) {
      closeTimer = setTimeout(function () { closePanelNow(item); }, 120);
    }

    navItems.forEach(function (item) {
      item.addEventListener('mouseenter', function () { openPanel(item); });
      item.addEventListener('mouseleave', function () { scheduleClose(item); });

      var trigger = item.querySelector('.pm-nav-item__trigger');
      var panelId = trigger && trigger.getAttribute('aria-controls');
      var panel = panelId && document.getElementById(panelId);

      if (panel) {
        panel.addEventListener('mouseenter', function () {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        });
        panel.addEventListener('mouseleave', function () { scheduleClose(item); });
      }

      if (trigger) {
        trigger.addEventListener('click', function () {
          if (item.classList.contains('pm-nav-item--open')) {
            closePanelNow(item);
          } else {
            openPanel(item);
          }
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openItem) closePanelNow(openItem);
    });

    document.addEventListener('click', function (e) {
      if (openItem && !openItem.contains(e.target)) {
        var panelId = openItem.querySelector('.pm-nav-item__trigger').getAttribute('aria-controls');
        var panel = document.getElementById(panelId);
        if (panel && !panel.contains(e.target)) closePanelNow(openItem);
      }
    });
  }

  /* ─── Sub-category hover (switches product group) ─── */
  function initSubCatHover() {
    document.querySelectorAll('.pm-megamenu-panel').forEach(function (panel) {
      var subCats = panel.querySelectorAll('.pm-subcategory[data-subcat]');
      var groups  = panel.querySelectorAll('.pm-product-group[data-group]');
      if (!subCats.length || !groups.length) return;

      subCats.forEach(function (cat) {
        cat.addEventListener('mouseenter', function () {
          var idx = cat.getAttribute('data-subcat');

          subCats.forEach(function (c) { c.classList.remove('pm-subcategory--active'); });
          cat.classList.add('pm-subcategory--active');

          groups.forEach(function (g) {
            if (g.getAttribute('data-group') === idx) {
              g.removeAttribute('hidden');
            } else {
              g.setAttribute('hidden', '');
            }
          });
        });
      });
    });
  }

  /* ─── Mobile Drawer ─── */
  function initMobileDrawer() {
    var wrappers = document.querySelectorAll('.pm-mobile-wrapper');
    if (!wrappers.length) return;

    wrappers.forEach(function (wrapper) {
      var drawer = wrapper.querySelector('.pm-mobile-drawer');

      function openDrawer() {
        wrapper.classList.add('is-open');
        wrapper.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        document.querySelectorAll('[aria-controls="' + wrapper.id + '"]').forEach(function (t) {
          t.setAttribute('aria-expanded', 'true');
        });
      }

      function closeDrawer() {
        wrapper.classList.remove('is-open');
        wrapper.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        document.querySelectorAll('[aria-controls="' + wrapper.id + '"]').forEach(function (t) {
          t.setAttribute('aria-expanded', 'false');
        });
        setTimeout(function () {
          if (drawer) drawer.classList.remove('is-l2');
          wrapper.querySelectorAll('.pm-mobile-panel--l2.is-active').forEach(function (p) {
            p.classList.remove('is-active');
          });
        }, 300);
      }

      document.querySelectorAll('[aria-controls="' + wrapper.id + '"]').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          wrapper.classList.contains('is-open') ? closeDrawer() : openDrawer();
        });
      });

      wrapper.querySelectorAll('[data-close-drawer]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });

      wrapper.querySelectorAll('[data-open-l2]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var blockId = btn.getAttribute('data-open-l2');
          var l2Panel = wrapper.querySelector('.pm-mobile-panel--l2[data-block="' + blockId + '"]');
          if (!l2Panel || !drawer) return;
          l2Panel.classList.add('is-active');
          drawer.classList.add('is-l2');
        });
      });

      wrapper.querySelectorAll('[data-go-back]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!drawer) return;
          var l2Panel = btn.closest('.pm-mobile-panel--l2');
          drawer.classList.remove('is-l2');
          if (l2Panel) setTimeout(function () { l2Panel.classList.remove('is-active'); }, 300);
        });
      });

      /* Swipe to close (left swipe on L1) */
      var touchStartX = 0;
      wrapper.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      wrapper.addEventListener('touchend', function (e) {
        if (drawer && drawer.classList.contains('is-l2')) return;
        if (touchStartX - e.changedTouches[0].clientX > 60 && wrapper.classList.contains('is-open')) {
          closeDrawer();
        }
      }, { passive: true });
    });
  }

  /* ─── Search category custom picker ─── */
  function initSearchCatPicker() {
    document.querySelectorAll('[data-cat-picker]').forEach(function (picker) {
      var trigger  = picker.querySelector('[data-cat-trigger]');
      var dropdown = picker.querySelector('[data-cat-dropdown]');
      var labelEl  = picker.querySelector('[data-cat-label]');
      var input    = picker.querySelector('input[data-cat-input]');
      if (!trigger || !dropdown) return;

      function open() {
        dropdown.removeAttribute('hidden');
        trigger.setAttribute('aria-expanded', 'true');
      }
      function close() {
        dropdown.setAttribute('hidden', '');
        trigger.setAttribute('aria-expanded', 'false');
      }

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        dropdown.hasAttribute('hidden') ? open() : close();
      });

      dropdown.querySelectorAll('[data-cat-value]').forEach(function (option) {
        option.addEventListener('click', function () {
          var val  = option.getAttribute('data-cat-value');
          var text = option.textContent.trim();
          if (input)  input.value = val;
          if (labelEl) labelEl.textContent = text;
          dropdown.querySelectorAll('[data-cat-value]').forEach(function (o) {
            o.classList.remove('pm-searchbar__cat-option--selected');
            o.setAttribute('aria-selected', 'false');
          });
          option.classList.add('pm-searchbar__cat-option--selected');
          option.setAttribute('aria-selected', 'true');
          close();
        });
      });

      document.addEventListener('click', function (e) {
        if (!picker.contains(e.target)) close();
      });
    });
  }

  /* ─── Init ─── */
  function init() {
    initDesktopMegamenu();
    initSubCatHover();
    initMobileDrawer();
    initSearchCatPicker();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
